/**
 * Metadata van de voices van de keel (Communicatie cheat sheet), voor het
 * voices-paneel en de klikbare voice-iconen. De groepssleutels volgen de
 * `human-design/communication`-scope (`groups.<key>`); de cheat-sheet-pagina
 * houdt haar eigen (layout-gekoppelde) groepslijst. Dit is de leesvolgorde
 * voor het paneel, met één afwijking van de poster: de twee projector-blokken
 * (16 en 33, op de poster gescheiden door de wiel-layout) delen dezelfde kop
 * en punten en vormen in het paneel dus één groep.
 */
export type HdVoiceGroupKey =
  | 'metamorphic'
  | 'experiment'
  | 'now'
  | 'leadership'
  | 'emotionMotor'
  | 'willpower';

export interface HdVoiceGroupDefinition {
  readonly key: HdVoiceGroupKey;
  readonly gates: readonly number[];
}

export const HD_VOICE_PANEL_GROUPS: readonly HdVoiceGroupDefinition[] = [
  { key: 'metamorphic', gates: [62, 23, 56] },
  // "Projector poorten": 16 én 33 (de kop/punten van groups.experiment en
  // groups.memory zijn identiek; het paneel gebruikt de experiment-content).
  { key: 'experiment', gates: [16, 33] },
  { key: 'now', gates: [20] },
  { key: 'leadership', gates: [31, 8] },
  { key: 'emotionMotor', gates: [35, 12] },
  { key: 'willpower', gates: [45] },
];

/** Alle elf keelpoorten, in de paneel-leesvolgorde. */
export const HD_THROAT_VOICE_GATES: readonly number[] = HD_VOICE_PANEL_GROUPS.flatMap(
  group => [...group.gates],
);

/** Is dit een keelpoort met een voice (en dus een sectie in het voices-paneel)? */
export function hdIsThroatVoiceGate(gate: number): boolean {
  return HD_THROAT_VOICE_GATES.includes(gate);
}

/** Paneel-key van het voices-paneel (dedup in de FloatingPanelService). */
export const HD_THROAT_VOICES_PANEL_KEY = 'throat-voices';

/** Wiel-diagram van de keel-voices (gedeeld met de Communicatie cheat sheet). */
export const HD_THROAT_VOICES_WHEEL_ASSET =
  'assets/human-design/communication/throat-voices-wheel.png';

/** `FLOATING_PANEL_DATA` van het voices-paneel. */
export interface HdThroatVoicesPanelData {
  /** Poort waar het paneel na openen naartoe scrollt, of `null`. */
  readonly focusGate: number | null;
}
